import Notification from '@polleverywhere/toolkit-notification'

import '../notification/notify'
import '../notification/cookie_banner'

import '../notification/notification.scss'

PollEv.namespace('PollEv.Component', (Component) => {
  Component.Notification = Notification
})
